import { useContext } from "react";
import TouchpointContext from "../context/touchpointProvider";

const useTouchpoint = () => {
    const { questionValues, setQuestionValues } = useContext(TouchpointContext);
    const { headerValues, setHeaderValues } = useContext(TouchpointContext);
    const { searchValues, setSearchValues } = useContext(TouchpointContext);
    const { pageValues, setPageValues } = useContext(TouchpointContext);
    const { search, setSearch } = useContext(TouchpointContext);

    return {
        questionValues,
        setQuestionValues,
        headerValues,
        setHeaderValues,
        searchValues,
        setSearchValues,
        pageValues,
        setPageValues,
        search,
        setSearch,
    };
};

export default useTouchpoint;
